import { connect } from 'react-redux';
import ChangeMarketingApproval from './ChangeMarketingApproval';
import { isLoadingSelector } from '../../modules/LoadingStatus/reducer';
import { customerOptionCommercialSelector } from '../../modules/Customer/selectors';
import { confirmCustomerOptionCommercial } from '../../modules/Customer/actions';

const mapStateToProps = state => ({
  customerOptionCommercial: customerOptionCommercialSelector(state),
  isLoading: isLoadingSelector(state, 'confirmCustomerOptionCommercial'),
});

const mapDispatchToProps = {
  confirmCustomerOptionCommercial,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeMarketingApproval);
